var _ellipse, _ellipse2, _ellipse3, _path, _polygon, _polygon2, _polygon3, _ellipse4, _ellipse5, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _path12, _circle3, _path13, _path14, _path15, _polygon4, _path16, _circle4, _path17, _circle5, _path18, _path19, _path20, _path21, _path22, _ellipse6, _path23, _path24, _path25, _polygon5, _ellipse7, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 994.40534,
    height: 678.13326,
    viewBox: "0 0 994.40534 678.13326",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.66161,
    cy: 736.43531,
    rx: 179.86451,
    ry: 11.68958,
    transform: "translate(-103.97896 -110.47875) rotate(-0.09196)",
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 663.12685,
    cy: 585.77243,
    rx: 141.22814,
    ry: 9.17856,
    transform: "translate(-103.73665 -109.86828) rotate(-0.09196)",
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 918.75577,
    cy: 722.29912,
    rx: 178.44712,
    ry: 31.53382,
    transform: "translate(-103.95545 -109.45782) rotate(-0.09196)",
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.35,418.14321l20.25283-5.6388s7.9329-1.58366,3.08564-17.07679-14.46094-11.15706-14.46094-11.15706l-17.96631,5.21965-7.09323,2.19056,9.9805,14.00177.83659,9.33246Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "167.418 266.274 161.064 291.656 193.622 323.209 196.421 323.911 203.888 321.813 210.243 296.433 203.806 289.664 210.385 287.94 196.345 274.31 189.019 275.848 183.142 270.013 187.108 268.428 187.483 266.935 182.678 263.153 167.418 266.274",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.922 302.074 193.716 318.87 174.312 300.526 179.171 283.496 197.922 302.074",
    fill: "#e0bad7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.418 266.274 166.527 269.833 198.902 301.328 201.701 302.029 208.936 300.071 209.334 300.063 210.243 296.433 203.806 289.664 210.385 287.94 196.345 274.31 189.019 275.848 183.142 270.013 187.108 268.428 187.483 266.935 182.678 263.153 167.418 266.274",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.17096,
    cy: 376.88627,
    rx: 1.82771,
    ry: 2.69344,
    transform: "translate(-252.48941 451.04714) rotate(-75.94348)",
    fill: "#e0bad7"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.73877,
    cy: 404.0502,
    rx: 1.82771,
    ry: 2.69344,
    transform: "translate(-263.26764 491.56547) rotate(-75.94348)",
    fill: "#e0bad7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.80624,449.76143l-4.41669-15.01664s11.48327-27.38328-1.76667-30.03328-14.1333,25.61662-14.1333,25.61662l5.3,16.7833Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb6b6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.00777,
    cy: 274.54162,
    r: 35.08838,
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.15721,410.24325s2.064,25.80028,7.22406,27.86428-46.13421,16.51224-46.13421,16.51224l15.48017-17.54421s-6.49833-26.83227-13.72233-33.02434Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.60628,441.81141l14.13331-1.76667s16.78326,8.83332,16.78326,20.31663,9.71669,30.03328,9.71669,30.03328,7.06665,24.73328-8.83332,26.49995S303.373,490.39465,303.373,490.39465Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#e0bad7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309.55623,582.26106l28.49157-19.62751a27.60654,27.60654,0,0,1,30.88791-.5582c3.92592,2.61728,6.87036,6.05246,6.87036,10.4691,0,13.24994-29.14991,44.16658-29.14991,44.16658S324.5729,665.29424,303.373,667.0609a365.84549,365.84549,0,0,0-41.51655,6.18328s9.71661,35.33327,4.41665,45.04988-25.61661,21.2-27.38328,20.31659-26.5-23.84992-37.09993-56.53322-17.66663-57.41652-7.95-59.18318S309.55623,582.26106,309.55623,582.26106Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.15611,569.89442s6.18328-.88337,5.3,14.13331-3.53333,68.89986-7.95,79.49984-5.3,22.96663-3.53333,27.38325,5.3,11.48327-.8833,12.36664-31.79993-2.65-34.44989-3.53333,10.60005-35.33326,8.83339-37.09985-3.53333-43.28322-3.53333-43.28322Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.32279,700.6275s15.0166-4.41669,16.78327,5.3c0,0,2.65,15.0166-8.83332,20.31659a141.90915,141.90915,0,0,0-21.2,12.36665s-18.54993,7.06665-19.4333-1.76667,3.5334-40.63325,3.5334-40.63325Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.50635,711.22748l-28.26661-22.96662s5.3,28.26661-1.76666,33.5666l-3.22794,9.43714,9.03915,7.39414S268.03968,734.1941,264.50635,711.22748Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.75643,672.36089s18.55,5.3,15.9,23.84992-6.04768,38.70314-6.04768,38.70314-1.019,49.63-14.26891,53.16335-16.7833-3.53333-16.7833-3.53333-15.06151-38.78234-10.6-50.34987c5.40042-14.00147,13.18226-29.72305,10.6-34.44989C201.01562,695.093,205.32317,669.71086,224.75643,672.36089Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.15649,428.56147s7.06665.88333,18.55,2.65,19.4333-7.06665,25.61662-5.3,57.41652,14.13327,57.41652,14.13327L311.30817,474.019c-1.45245,11.13551-5.06,21.79814-9.68083,32.03321-7.45073,16.50309,3.58876,68.20231,14.11224,77.97557,9.15356,8.501,21.2,10.6,7.95,25.61657S287.47305,637.911,240.65647,633.4943s-52.99986-3.53333-52.99986-10.6,16.661-99.81644,11.361-105.11643-7.95-10.6-7.95-13.24994c0-1.77138-5.52582-21.699-9.18993-34.71816a37.107,37.107,0,0,1,2.76456-27.52819c1.65829-3.10329,3.55452-5.48626,5.542-5.77018,6.18329-.88333,1.88891-5.3,6.3056-5.3s7.06665.88333,9.71665,0Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#e0bad7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M281.86034,361.80742s-.79895-43.36023-43.35963-22.83495c0,0-32.72593-1.154-37.30581,40.243l-4.428,43.33936,4.74333-3.56616,3.178,4.901,8.66787.8856,2.53061-7.624,2.99912,8.36411,69.44685-3.25629s-33.32357-13.6141-38.5945-46.033l6.74758,5.31032Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.07293,
    cy: 233.85934,
    r: 17.3954,
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.983,337.96795a17.3817,17.3817,0,0,0-19.57044-13.5517c.34873-.09742.69284-.20409,1.05177-.28075a17.39539,17.39539,0,1,1,7.26686,34.0234c-.35893.07666-.71659.11987-1.07469.17342A17.38168,17.38168,0,0,0,218.983,337.96795Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.81211,
    cy: 76.46672,
    r: 28.67357,
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M659.70627,206.48938s-.4317,17.69936,1.2951,18.13106-23.743,7.33878-23.743,7.33878l-2.59013-24.17475Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M458.538,357.58143s-18.99442,0-19.42612-2.15844-4.31692,17.69933-4.31692,17.69933l7.77045,2.59013s14.6775-6.47535,15.97259-6.47535S458.538,357.58143,458.538,357.58143Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437.8168,365.35187s3.45352-11.65567,7.77044-12.08737c0,0-14.6775-9.49724-15.10919-12.51906s-5.612-10.79228-7.77045-8.20215-2.15849,43.60086,1.72679,47.91778,21.15291-6.06774,21.15291-6.06774S434.79491,369.6688,437.8168,365.35187Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "569.428 419.757 572.881 438.319 556.909 440.909 556.909 419.757 569.428 419.757",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M672.22534,547.09407s2.59013-8.20214,4.31692-6.90705,4.31693,9.49724,3.88523,11.65567-3.45353,18.99443-2.15844,22.01625-6.47535,18.56273-16.40429,17.26769-9.06554-9.92894-9.06554-9.92894l3.45353-13.3824,1.29509-21.15292S668.77181,544.93558,672.22534,547.09407Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 551.84255,
    cy: 46.28802,
    r: 11.86494,
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M670.45981,150.79457a11.86611,11.86611,0,0,0-10.629-11.80077,11.98577,11.98577,0,0,1,1.236-.06414,11.86493,11.86493,0,0,1,0,23.72985,12.00825,12.00825,0,0,1-1.236-.06414A11.86613,11.86613,0,0,0,670.45981,150.79457Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.7997,
    cy: 89.51232,
    r: 18.13104,
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M680.42749,326.49963s-.8634,21.58456-4.31692,32.80859-15.90438,91.15833-13.31419,97.202,15.90437,72.88448,12.88254,76.76971-17.26768,2.59013-17.26768,2.59013l-19.3579-81.08663s3.817-89.4316-28.12819-91.59-84.1799-3.45352-84.1799-3.45352-33.67192,9.92888-48.78112,9.49724-23.743,3.88522-23.743,3.88522L451.631,355.42305l66.91221-14.6775s61.30019-21.15291,94.97217-15.5409S680.42749,326.49963,680.42749,326.49963Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M656.25275,219.00842s5.18031-3.02186,6.47535,0,10.36058,5.612,13.81416,3.02186,12.08737.86339,12.08737.86339l9.49724,28.06s-4.74862,24.17474-9.06554,37.55718-6.04371,41.0107-4.31692,43.60089-34.53532,12.95076-52.23471,6.47535-21.58461-13.81416-21.58461-13.81416,19.42612-27.62827,12.95077-40.579-1.29509-27.62826-1.29509-27.62826l-2.59014-14.67753,14.67751-8.20215s.86339-7.77045,4.31692-7.77045S656.25275,219.00842,656.25275,219.00842Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#d0cde1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M626.466,242.31977h-6.47536a14.49211,14.49211,0,0,0-4.31692,13.38243c1.72679,8.20215,9.51437,35.39472,9.51437,35.39472l6.45823-16.832Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#d0cde1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M607.87142,311.64706s-12.91886,13.98918-3.42162,21.32793,11.83741-16.83594,11.83741-16.83594Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M626.466,282.4671l-3.02183,12.08737-5.18032,9.49721s-17.69933,11.65568-17.69933,15.9726c0,0,7.77045-9.92891,17.69933,0l8.84967-21.36874Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#d0cde1"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.47659,
    cy: 70.3872,
    rx: 19.77488,
    ry: 11.86494,
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M680.42749,182.31464s-13.81417-7.77045-19.42612-2.15846,16.836,14.24583,16.836,14.24583Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M685.60775,225.05211l3.02183-2.15847s3.45352-5.18028,6.47535-3.45352,20.72122-6.47539,20.72122-6.47539-6.47536,3.02186-6.47536-2.15846-.8634-4.31692-5.18032-4.31692-4.31692,2.15846-6.04371-.86339-.8634-4.74862-3.88523-3.02186-6.47535.4317-7.33875-.8634-16.40429-3.45352-16.40429-3.45352,6.04372-17.69936,7.33875-18.99443,34.53538,13.3825,34.53538,13.3825,41.87407,11.65567,31.08179,25.03811-49.64452,33.672-49.64452,33.672Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#d0cde1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M766.407,110.93337l77.88066.48372s128.18864,68.206,38.21472,209.45538c0,0-36.76358-8.70716-77.39692,21.28414C805.1055,342.15665,781.40273,116.25441,766.407,110.93337Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#e0bad7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M789.574,111.64041c13.95271,58.28271,29.72574,208.60515,29.72574,208.60515,36.303-26.795,69.49344-22.703,76.1605-21.526a257.991,257.991,0,0,1-12.95789,22.71607s-36.76351-8.70716-77.39685,21.28414c0,0-23.70277-225.9022-38.69846-231.22324Z",
    transform: "translate(-102.79733 -110.93337)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "780.189 73.043 786.961 105.937 872.069 90.467 872.097 90.457 874.032 51.759 857.586 51.759 780.189 73.043",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "858.959 51.759 872.069 90.467 872.097 90.457 874.032 51.759 858.959 51.759",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 783.09119,
    cy: 87.55526,
    rx: 9.67463,
    ry: 22.25161,
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M936.1965,668.72927a2.95688,2.95688,0,0,1-2.95711-2.95672V198.48874a2.95715,2.95715,0,1,1,5.9143,0V665.77209a2.95688,2.95688,0,0,1-2.95666,2.95718Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M895.56706,750.9642a2.95575,2.95575,0,0,1-2.90634-3.52317l37.74844-193.52018L831.28165,705.12513a2.95748,2.95748,0,1,1-4.94629-3.24359h0L933.72328,538.07937a2.95762,2.95762,0,0,1,5.376,2.18781L898.46636,748.57307A2.95887,2.95887,0,0,1,895.56706,750.9642Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.42434,714.19986a2.95279,2.95279,0,0,1-2.47544-1.33651L933.72335,541.62329a2.95685,2.95685,0,1,1,4.94629-3.24129h0l112.22554,171.24006a2.95733,2.95733,0,0,1-2.47084,4.5778Z",
    transform: "translate(-102.79733 -110.93337)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg-4.e051ba97c5dc78a8b98eac1e0635ae50.svg";
export { ForwardRef as ReactComponent };